import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tab,
  Tabs,
  TextField,
  Typography,
  Link,
  ListItemIcon,
  CircularProgress,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  styled,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import React, { useCallback, useEffect, useRef, useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import { Margin, Padding } from "@mui/icons-material";
import Swal from "sweetalert2";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DetailDocPersonal from "./DetailDocPersonal";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import personimage from "../../../../Image/image.png";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import DocumentSequenceDialog from "./SignSignatureDialog";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ApartmentIcon from "@mui/icons-material/Apartment";
import Approveimage from "../../../../Image/approve.png";
import Attachmentsimage from "../../../../Image/attachments.png";
import no_documents from "../../../../Image/no_documents.png";
import icon_pdf from "../../../../Image/icon_pdf.png";
import logo_del from "../../../../Image/logo_del.png";
import icon_import from "../../../../Image/icon_import.png";
import icon_hospital from "../../../../Image/icon_hospital.png";
import Autocomplete from "@mui/material/Autocomplete";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { PDF_example, PDF_example3page } from "./Base64";
import icon_doc from "../../../../Image/icon_doc.png";
import DescriptionIcon from "@mui/icons-material/Description";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useHistory, useLocation } from "react-router-dom";
import ErroPagerPDF from "./ErroPagerPDF";
import BadgeIcon from "@mui/icons-material/Badge";
import SignSignatureDialog from "./SignSignatureDialog";
import SignatureDrawing from "./SignatureDrawing";
import DialogAttachDocPDF from "./DialogAttachDocPDF";
import LoadingIndicator from "../PersonalDataAgreementComponent/Loading/LoadingIndicator";
import DialogNoInformationFound from "../../../DSA-NDADComponent/User/PersonalDataAgreementComponent/DialogPersonal/DialogNoInformationFound";

import {
  APIEndpointWeb,
  webapi,
  GetLocalStorageAccessToken,
  GetLocalStorageOrganization,
  GetLocalStorageData,
} from "../../../../client/web";
import TestPosition from "./TestPosition";
import DialogShowSignPDFV1 from "../FormPersonal/DialogShowSignPDFV1";

const top100Films = [
  { title: "The Shawshank Redemption", year: 1994 },
  { title: "The Godfather", year: 1972 },
  { title: "The Godfather: Part II", year: 1974 },
  { title: "The Dark Knight", year: 2008 },
  { title: "12 Angry Men", year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: "Pulp Fiction", year: 1994 },
];

const prefix = [
  { prefix: 'นาย', gender: 'นาย' },
  { prefix: 'นาง', gender: 'นาง' },
  { prefix: 'นางสาว', gender: 'นางสาว' },
];

interface Film {
  title: string;
  year: number;
}

interface Prefix {
  prefix: string;
  gender: string;
}

export interface PdfArray {
  type: string;
  pdf_base64: string;
}

interface SeleteItem {
  name: string;
  value: string;
}

interface FileBase64 {
  name: string;
  base64: any;
}

interface getFileInterface {
  files_name: string;
  _id: string;
}
interface LocationState {
  message?: string;
  // document_list: any[];
  dataform: any;
}

const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

const IndexDocumentPer = () => {
  const [valueTab, setValueTab] = useState("1");
  const [resetInputPDF, setResetInputPDF] = useState<string>("");
  const [PDFUrl, setPDFUrl] = useState<string>("");
  const [selectedFiles, setSelectedFiles] = useState<FileBase64[]>([]);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<Film[]>([]);
  const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);
  const [inputValueAutocomplete, setInputValueAutocomplete] = useState("");
  const [inputValuePrefix, setInputValuePrefix] = useState("");
  const [optionsPrefix, setOptionsPrefix] = useState<Prefix[]>([]);
  const [openPrefix, setOpenPrefix] = useState(false);
  const [loadingPrefix, setLoadingPrefix] = useState(false);
  const history = useHistory();
  const [selectDoc, setSelectDoc] = useState("");
  const [scale, setScale] = useState<number>(0.6);
  const [scaleForReset, setScaleForReset] = useState<number>(0.6);
  const [errorPDF, setErrorPDF] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [cid, setCid] = useState<string>("");
  const [nameData, setNameData] = useState<string>("");
  const [errorCid, setErrorCid] = useState<string>("");
  //////////////////////////////////////////////////////////////////////////////////////
  const [arrrayOfPdf, setArrrayOfPdf] = useState<PdfArray[]>([]);
  const [valuePdf, setvaluePdf] = useState<PdfArray>({
    type: "",
    pdf_base64: "",
  });

  const [arrrayOfSelete, setArrrayOfSelete] = useState<SeleteItem[]>([]);

  const [getFiles, setGetFiles] = useState<getFileInterface[]>([]);
  const [accessToken, setAccessToken] = useState<string>(
    GetLocalStorageAccessToken()
  );
  const [base64OfSign, setBase64OfSign] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [openNoInformationFound, setOpenNoInformationFound] = useState<boolean>(false);

  const [selectedValue, setSelectedValue] = useState("นาย");
  // const [arrrayOfSelete, setArrrayOfSelete] = useState<SeleteItem[]>([
  //   { value: "NDA", name: "เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (NDA)" },
  //   {
  //     value: "DSA",
  //     name: "ใบสมัครเข้าร่วมตามนโยบาย “๓๐ บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว” ของหน่วยบริการเอกชน",
  //   },
  //   // {
  //   //   value: "ThirtyBaht",
  //   //   name: "ใบสมัครเข้าร่วมตามนโยบาย “๓๐ บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว” ของหน่วยบริการเอกชน",
  //   // },
  // ]);
  ////////////////////////////////////////////////////////////////////////
  const [openSecondDialog, setOpenSecondDialog] = useState(false);
  const [openAttachDoc, setOpenAttachDoc] = useState<boolean>(false);
  const [localStorageOrganization, setLocalStorageOrganization] = useState<any>(null);
    const [localStorageData, setLocalStorageData] = useState<any>(null);

  const location = useLocation<LocationState>();
  const messageDetail = location.state?.message;

  const viewerRef = useRef(null);

  const hiddenFileInputCreatePDF = useRef<HTMLInputElement>(null);

  const dataPageForm = location.state || {};
  

  useEffect(() => {
    if (!open) {
      setOptions([]);
      return;
    }

    setLoadingAutocomplete(true);
    sleep(1000).then(() => {
      setLoadingAutocomplete(false);
      setOptions(top100Films);
    });
  }, [open]);

  useEffect(() => {
    if (!openPrefix) {
      setOptions([]);
      return;
    }
    setLoadingPrefix(true);
    sleep(500).then(() => {
      setLoadingPrefix(false);
      setOptionsPrefix(prefix);
    });
  }, [openPrefix]);
  // console.log('localStorageOrganization :>> ', localStorageOrganization);

  useEffect(() => {
    if (dataPageForm.dataform) {
      console.log("dataPageForm", dataPageForm)
      let array_empty: PdfArray[] = [];
      let array_selete: SeleteItem[] = [];
      for (let index in dataPageForm.dataform.document_list) {
        if (Number(index) === 0) {
          setvaluePdf({
            type: dataPageForm.dataform.document_list[index].type,
            pdf_base64: dataPageForm.dataform.document_list[index].pdf_base64,
          }); /// set ค่าเริ่มต้น
          setSelectDoc(dataPageForm.dataform.document_list[index].type); /// set ค่าเริ่มต้น
        }
        array_selete.push({
          name: dataPageForm.dataform.document_list[index].type,
          value: dataPageForm.dataform.document_list[index].type,
        });
        array_empty.push({
          type: dataPageForm.dataform.document_list[index].type,
          pdf_base64: dataPageForm.dataform.document_list[index].pdf_base64,
        });
      }
      setArrrayOfSelete(array_selete);
      setArrrayOfPdf(array_empty);
      getFilesPDF();
      // getSignatureByProvider() // ลบก่อน
    } else {
      // history.push("/form-personal");
    }

    let glso = GetLocalStorageOrganization()
    setLocalStorageOrganization(glso)

    let glsd = GetLocalStorageData();
    setLocalStorageData(glsd);
    /////////////////////////////////////////////////////////////////////////////////
    const container: any = viewerRef.current;
    if (container) {
      const handleResize = () => {
        const newScale = container.clientWidth / 1012; // 612 is the default width of the page in points
        setScale(newScale);
        setScaleForReset(newScale);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  const getFilesPDF = async () => {
    try {
      setLoading(true);
      var datax = {
        account_id: dataPageForm.dataform.one_id,
        hcode: dataPageForm.dataform.hcode,
      };
      var { data } = await webapi.post(
        `${APIEndpointWeb.PostGetListfilesPDF}`,
        datax,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      setGetFiles(data.result && data.result.length > 0 ? data.result : []);
    } catch (error) {
      setGetFiles([]);
    } finally {
      setLoading(false);
    }
  };

  const deleteFilesPDF = async (idOfFile: string) => {
    try {
      setLoading(true);
      var { data } = await webapi.delete(
        `${APIEndpointWeb.DeleteFilesPDF}?_id=${idOfFile}&account_id_by_one_id=${dataPageForm.dataform.one_id}&hcode=${dataPageForm.dataform.hcode}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      getFilesPDF();
      setLoading(false);
      Swal.fire({
        title: "ลบเอกสารสำเร็จ",
        text: "",

        confirmButtonText: "ตกลง",
        icon: "success",
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
      getFilesPDF();
      Swal.fire({
        title: "ลบไฟล์ไม่สำเร็จ",
        text: "",

        confirmButtonText: "ตกลง",
        icon: "error",
      });
    }
  };

  /////////////////////////////////////////////////////////////////////////////////////////// ลบก่อน
  const getSignatureByProvider = async () => {
    try {
      setLoading(true);
      var datax = {
        account_id: dataPageForm.dataform.one_id,
        cid: dataPageForm.dataform.cid,
        priority: Number(dataPageForm.dataform.priority)
      };


      var { data } = await webapi.post(`${APIEndpointWeb.PostSignaturebyProvider}`, datax,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      // setBase64OfSign(data.result.data ? data.result.data : '')
    } catch (error) {
      console.log(error)
      setBase64OfSign('')
    } finally {
      setLoading(false);
    }
  };


  const getSignatureByProviderTwo = async () => {
    try {
      setLoading(true);
      var datax = {
        account_id: dataPageForm.dataform.one_id,
        cid: cid,
        priority: 1
      };
      var { data } = await webapi.post(`${APIEndpointWeb.PostSignaturebyProvider}`, datax,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      setBase64OfSign(data.result.data ? data.result.data : '')
      //  console.log(data.result)
      //  if () {

      //  }
      //  setOpenNoInformationFound(true)
      // setBase64OfSign(data.result.data ? data.result.data: '')
      setOpenSecondDialog(true);
    } catch (error: any) {
      console.log(error)
      try {
        // error.response.data.status_result.status_message_th
        if (!error.response || error.response.status === 400) {
          setOpenNoInformationFound(true)
        } else {
          Swal.fire({
            title: error.response.data.status_result.status_message_th,
            icon: "error",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "ไม่สามารถลงนามเอกสารได้ กรุณาติดต่อผู้ดูแลระบบ",
          icon: "error",
        });
      }
    } finally {
      setLoading(false);
    }
  };
  ////////////////////////////////////////////////////////////////////////////////////////////// อันนี้เดียวกัน

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);
  const handleOpenPrefix = useCallback(() => setOpenPrefix(true), []);
  const handleClosePrefix = useCallback(() => setOpenPrefix(false), []);

  const handleOpenSecondDialog = () => {
    // alert("master fucker");
    getSignatureByProviderTwo()
    // setOpenSecondDialog(true);
  };

  const handleChangeSelectDoc = (event: SelectChangeEvent) => {
    setSelectDoc(event.target.value as string);
    var xml = arrrayOfPdf.find(
      (element) => element.type === event.target.value
    );
    if (xml) {
      setvaluePdf(xml);
    }
  };
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValueTab(newValue);
  };

  const convertFileToBase64 = (file: any) => {
    return new Promise((resolve) => {
      let baseURL: any;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  // const ChangeDeleteFile = (index: number) => {
  //   let arrDelete = selectedFiles;
  //   arrDelete.splice(index, 1);
  //   setSelectedFiles([...arrDelete]);
  // };

  const handleDelete = (fileName: string, _id: string) => {
    Swal.fire({
      title: "คุณต้องการลบเอกสารนี้ใช่หรือไม่?",
      text: fileName + ".pdf",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "ตกลง",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire({
        //   title: "ลบไฟล์สำเร็จ",
        //   text: fileName,
        //   confirmButtonText: "ตกลง",
        //   icon: "success",
        // }).then(() => {
        //   // ChangeDeleteFile(index);
        // });
        deleteFilesPDF(_id);
      }
    });
  };

  const handleDrop = (event: any) => {
    event.preventDefault();
    // const droppedFiles = Array.from(event.dataTransfer.files);
    const files = event.dataTransfer.files;
    const target = { files } as unknown as HTMLInputElement;
    const changeEvent = { target } as React.ChangeEvent<HTMLInputElement>;
    uploadPDF(changeEvent);
    // console.log("droppedFiles", droppedFiles)
    // setFiles(droppedFiles);
  };

  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  const uploadPDF = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      let fileArray = Array.from(files);

      // Limit to 5 files
      if (fileArray.length + selectedFiles.length > 5) {
        Swal.fire({
          title: "เลือกไฟล์มากเกินไป",
          text: "สามารถเลือกได้สูงสุด 5 ไฟล์เท่านั้น",
          icon: "warning",
  
          confirmButtonText: "ตกลง",
        });
        return false;
      }

      // Validate file type and size
      fileArray = fileArray.filter((file) => {
        if (file.type !== "application/pdf") {
          Swal.fire({
            title: "ไฟล์ไม่ถูกต้อง",
            text: `ไฟล์ "${file.name}" ไม่ใช่ PDF`,
            icon: "error",
    
            confirmButtonText: "ตกลง",
          });
          return false;
        }

        if (file.size > 2 * 1024 * 1024) {
          Swal.fire({
            title: "ไฟล์ใหญ่เกินไป",
            text: `ไฟล์ "${file.name}" มีขนาดเกิน 2MB`,
            icon: "error",
    
            confirmButtonText: "ตกลง",
          });
          return false;
        }

        return true;
      });

      if (fileArray.length === 0) {
        return false;
      }
      // var jsonParseOFselectedFiles: File[] = []
      var jsonBase64: FileBase64[] = [];
      selectedFiles.map(async (data) => {
        jsonBase64.push(data);
      });
      //  fileArray.map(async (data) =>  {
      //     // jsonParseOFselectedFiles.push(data)
      //     // let base64 = await convertFileToBase64(data)
      //     let filebase64 : FileBase64 =  {name: data.name, base64: "base64"}
      //     jsonBase64.push(filebase64)
      // })
      for (var xml in fileArray) {
        try {
          let base64 = await convertFileToBase64(fileArray[xml]);
          let filebase64: FileBase64 = {
            name: fileArray[xml].name,
            base64: base64,
          };
          jsonBase64.push(filebase64);
        } catch (error) {
          console.log("error", error);
        }
      }

      // console.log("jsonParseOFselectedFiles", jsonBase64);
      setSelectedFiles(jsonBase64);
      // Convert files to base64
      // const base64Files = await Promise.all(fileArray.map(getBase64File));
      // console.log("Uploaded PDFs:", base64Files);
    } catch (error) {
      console.error("File upload error:", error);
    } finally {
      e.target.value = ""; // Reset input field
    }
  };

  const triggerFileInput = () => {
    setOpenAttachDoc(true);
    if (hiddenFileInputCreatePDF.current) {
      hiddenFileInputCreatePDF.current.click();
    }
  };

  const HoverIconButton = styled(IconButton)({
    backgroundColor: "transparent",
    borderRadius: 3,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      // Change background on hover
    },
  });

  const findArraySelete = (value: string): string => {
    const xml = arrrayOfSelete.find((element) => element.value === value);

    if (xml) {
      console.log('xml.name :>> ', xml.name);

      if (xml.name === "register") {
        return "ใบสมัครเข้าร่วมตามนโยบาย “๓๐ บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว” ของหน่วยบริการเอกชน";
      } else {
        return "เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (DSA)";
      }
    }

    return "";
  };
  const onDocumentLoadSuccess = (numPages: any) => {
    // console.log(numPages._pdfInfo.numPages)
    setErrorPDF("");
    setTotalPage(numPages._pdfInfo.numPages);
    setPageNumber(1);
    setScale(scaleForReset);
  };

  const onLoadError = (error: Error) => {
    console.error("Error while loading document:", error);
    setTotalPage(1);
    setPageNumber(1);
    setErrorPDF("There was an error loading the PDF document.");
  };

  const isValidThaiIdCard = (id: string): boolean => {
    if (!/^[1-9]\d{12}$/.test(id)) return false;

    let sum = 0;
    for (let i = 0; i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i);
    }
    const checkDigit = (11 - (sum % 11)) % 10;

    return checkDigit === parseInt(id.charAt(12));
};

  const handleCid = (event: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = event.target.value.replace(/\D/g, "").slice(0, 13); // Remove all non-digits and limit to 13 characters

    setCid(inputValue);
    if (inputValue.length === 13) {
      if (isValidThaiIdCard(inputValue)) {
        setErrorCid("")
      } else {
        setErrorCid("errorValidThaiIdCard")
      }
    } else {
      setErrorCid("errorLength"); // Invalid input, show error
    }
  };


  const handleName = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setNameData((e.target.value as string).trimStart());
  };

  const handleChangePrefix = (event: SelectChangeEvent<string>) => {
    setSelectedValue(event.target.value as string);
  };

  return (
    <Box sx={{ height: "100%" }}>
      <LoadingIndicator open={loading} />
      <Grid item xs={12} md={12} lg={12}>
        <Box
          sx={{
            borderRadius: "15px",
            width: "100%",
            backgroundColor: "#ffffff",
            p: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            <Link href="/document-personal" underline="none">
              <NavigateBeforeIcon
                sx={{
                  fontSize: 30,
                  color: "#024F80",
                  ml: 1,
                  cursor: "pointer",
                  mr: 1,
                  mt: 2,
                }}
              />
            </Link>
            <Box>
              <Typography
                variant="h5"
                sx={{
                  fontSize: "18px",
                  mt: 2,
                  color: "#024F80",
                  fontWeight: 600,
                }}
              >
                เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (DSA/NDA)
              </Typography>
              <Box
                sx={{
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  mt: 1,
                  mb: 2,
                }}
              >
                <img
                  src={icon_hospital}
                  alt="icon_hospital"
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                />
                <Grid container>
                  <Grid item>
                    <Typography sx={{ ml: 1, mr: 1 }}>สถานพยาบาล :</Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ color: "#989898" }}>
                      {localStorageOrganization?.hname_th}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
          <Grid container sx={{ pl: 2, pr: 2, pb: 2 }} spacing={3}>
            <Grid item xs={12} md={12} lg={6} xl={7}>
              <Box
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#ffffff",
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    padding: 3,
                    backgroundColor: "#F0F3F6",
                    borderRadius: 3,
                  }}
                >
                  <Grid
                    container
                    spacing={1}
                    sx={{ alignItems: "center", mb: 2 }}
                  >
                    <Grid item xs={1} md={1}>
                      <img src={icon_doc} alt="icon_doc" width="30px" />
                    </Grid>
                    <Grid item xs>
                      <Typography>Document Preview</Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      md={12}
                      lg={12}
                      xl={7}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Select
                        size="small"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectDoc}
                        onChange={handleChangeSelectDoc}
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <DescriptionIcon fontSize="small" />
                            <Typography
                              sx={{
                                fontSize: "14px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {findArraySelete(selected)}
                            </Typography>
                          </Box>
                        )}
                        sx={{
                          fontSize: "12px", // ขนาดฟอนต์ของ Select
                          width: "100%",
                          borderRadius: "20px",
                          backgroundColor: "#0077CC",
                          color: "#ffffff",
                          "& .MuiSelect-select": {
                            padding: "6px 8px",
                            display: "flex",
                            alignItems: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontSize: "10px", // ปรับขนาดฟอนต์ตอนแสดงผล
                          },
                          "& .MuiSelect-icon": {
                            color: "#ffffff",
                          },
                        }}
                      >
                        {arrrayOfSelete.map((value, index) => (
                          <MenuItem key={index} value={value.value}>
                            <ListItemIcon>
                              <DescriptionIcon fontSize="small" />
                            </ListItemIcon>
                            <Typography sx={{ fontSize: "12px" }}>
                              {value.name === "register" ? "ใบสมัครเข้าร่วมตามนโยบาย “๓๐ บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว” ของหน่วยบริการเอกชน" : "เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (DSA)"}
                            </Typography>{" "}
                            {/* แสดงข้อความเต็ม */}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>

                  <Box
                    ref={viewerRef}
                    style={{
                      overflow: "auto",
                      width: "100%",
                      height: "100vh",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    {errorPDF ? (
                      <ErroPagerPDF />
                    ) : valuePdf.pdf_base64 ? (
                      <Document
                        file={`data:application/pdf;base64,${valuePdf.pdf_base64}`}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={onLoadError}
                      >
                        <Page
                          width={
                            window.screen.width > 1000
                              ? 1000
                              : window.screen.width - 20
                          }
                          pageNumber={pageNumber}
                          scale={scale}
                        />
                      </Document>
                    ) : (
                      ""
                    )}
                  </Box>
                  <Grid sx={{ display: "flex", justifyContent: "center" }}>
                    <Grid
                      container
                      xs="auto"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#323639",
                        padding: 0.5,
                        borderRadius: 2,
                        mt: 2,
                        gap: 1,
                      }}
                    >
                      <Grid item>
                        <HoverIconButton
                          aria-label="delete"
                          sx={{ color: "#ffffff" }}
                          size="medium"
                          onClick={() =>
                            pageNumber > 1
                              ? setPageNumber(pageNumber - 1)
                              : setPageNumber(1)
                          }
                        >
                          <ArrowBackIosIcon fontSize="small" />
                        </HoverIconButton>
                      </Grid>
                      <Grid item>
                        <Typography sx={{ color: "#ffffff" }}>
                          {pageNumber}/{totalPage}
                        </Typography>
                      </Grid>

                      <Grid item>
                        <HoverIconButton
                          aria-label="delete"
                          sx={{ color: "#ffffff" }}
                          size="medium"
                          onClick={() =>
                            pageNumber < totalPage
                              ? setPageNumber(pageNumber + 1)
                              : setPageNumber(totalPage)
                          }
                        >
                          <ArrowForwardIosIcon fontSize="small" />
                        </HoverIconButton>
                      </Grid>
                      <Grid item>
                        <Divider
                          sx={{
                            color: "#ffffff",
                            borderColor: "#ffffff",
                            borderWidth: "1px",
                            height: "30px",
                          }}
                          orientation="vertical"
                          flexItem
                        />
                      </Grid>
                      <Grid item>
                        <HoverIconButton aria-label="zoom-in" size="medium">
                          <ZoomInIcon
                            fontSize="medium"
                            sx={{ color: "#ffffff" }}
                            onClick={() =>
                              setScale((prevScale: number) => prevScale + 0.2)
                            }
                          />
                        </HoverIconButton>
                        <HoverIconButton aria-label="delete" size="medium">
                          <ZoomOutIcon
                            fontSize="medium"
                            sx={{ color: "#ffffff" }}
                            onClick={() =>
                              setScale((prevScale: number) =>
                                Math.max(prevScale - 0.2, 0.5)
                              )
                            }
                          />
                        </HoverIconButton>
                      </Grid>
                    </Grid>

                    {/* <button onClick={() => setScale((prevScale: number) => prevScale + 0.2)}><ZoomInIcon /></button> */}
                    {/* <button onClick={() => setScale((prevScale: number) => Math.max(prevScale - 0.2, 0.5))}>Zoom Out</button> */}
                    {/* <button onClick={() => setScale(0.6)}>Reset</button> */}
                  </Grid>
                  {/* <iframe
                    src={`data:application/pdf;base64,${PDF_example}`}
                    // src="https://example.com/sample.pdf"
                    width="100%"
                    height="100%"
                    style={{ border: "none" }}
                  /> */}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={12} lg={6} xl={5}>
              <Box
                sx={{
                  backgroundColor: "#f5fdff",
                  height: "100%",
                  borderRadius: 3,
                  border: "1px solid #dfebf7",
                }}
              >
                <Grid sx={{ padding: 2 }}>
                  {messageDetail === "detail_doc" ? (

                    <></>
                    // <DetailDocPersonal />
                  ) : (
                    <TabContext value={valueTab}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={handleChange}
                          aria-label="lab API tabs example"
                        >
                          <Tab
                            label={
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <img
                                  src={Approveimage}
                                  alt="icon"
                                  style={{
                                    width: 19,
                                    height: 19,
                                    textAlign: "center",
                                  }}
                                />
                                <Typography sx={{ ml: 1 }}>
                                  กำหนดผู้มีสิทธิ์อนุมัติ
                                </Typography>
                              </Box>
                            }
                            value="1"
                          />

                          <Tab
                            label={
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <img
                                  src={Attachmentsimage}
                                  alt="icon"
                                  style={{
                                    width: 19,
                                    height: 19,
                                    textAlign: "center",
                                  }}
                                />
                                <Typography sx={{ ml: 1 }}>
                                  แนบเอกสารเพิ่มเติม
                                </Typography>
                              </Box>
                            }
                            value="2"
                          />
                        </TabList>
                      </Box>

                      <TabPanel value="1">
                        <Grid
                          container
                          rowSpacing={1}
                          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        >
                          <Grid item xs={12} sx={{ mt: 3, ml: 1, mr: 1 }}>
                            <Typography sx={{ pl: 2, pb: 1 }}>
                              {"ลำดับที่ 1 : "}
                              <Typography
                                component="span"
                                sx={{ color: "#686868" }}
                              >
                                ผู้มีสิทธิ์อนุมัติ
                              </Typography>
                            </Typography>
                            <List sx={{ width: "100%" }}>
                              <Box
                                sx={{
                                  backgroundColor: "#E8F9FE",
                                  borderRadius: "12px",
                                  height: "90px",
                                }}
                              >
                                <ListItem alignItems="center">
                                  <ListItemAvatar>
                                    <img
                                      src={personimage}
                                      alt="รูปภาพ"
                                      style={{
                                        width: 22,
                                        height: "auto",
                                        top: 2,
                                      }}
                                    />
                                  </ListItemAvatar>

                                  <ListItemText
                                    primary={dataPageForm?.dataform?.approve_list && dataPageForm.dataform.approve_list.length > 0 ? dataPageForm.dataform.approve_list[0].name : "-"}
                                    secondary={
                                      <React.Fragment>
                                        <Typography
                                          component="span"
                                          variant="body2"
                                          sx={{
                                            display: "inline",
                                            color: "#686868",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {dataPageForm?.dataform?.approve_list && dataPageForm.dataform.approve_list.length > 0 ? dataPageForm.dataform.approve_list[0].email : "-"}
                                        </Typography>
                                      </React.Fragment>
                                    }
                                  />
                                </ListItem>
                              </Box>
                              <Box sx={{ paddingTop: 3 }}>
                                <Typography sx={{ pl: 2, pb: 1 }}>
                                  ลำดับที่ 2 :{" "}
                                  <Typography
                                    component="span"
                                    sx={{ color: "#686868" }}
                                  >
                                    ผู้มีสิทธิ์อนุมัติ
                                  </Typography>
                                </Typography>
                              </Box>
                              <Grid container spacing={2} sx={{ mt: 2 }}>
                                {/* คำนำหน้าชื่อ */}
                                <Grid item xs={12} md={12}>
                                  <Box
                                    sx={{
                                      // backgroundColor: "#E8F9FE",
                                      borderRadius: "12px",
                                    }}
                                  >
                                    <Typography
                                      sx={{ pl: 11, color: "#686868" }}
                                    >
                                      คำนำหน้าชื่อ
                                    </Typography>
                                    <ListItem alignItems="center">
                                      <ListItemAvatar>
                                        <img
                                          src={personimage}
                                          alt="รูปภาพ"
                                          style={{
                                            width: 25,
                                            height: "auto",
                                            position: "relative",
                                            bottom: 42,
                                          }}
                                        />
                                      </ListItemAvatar>

                                      <Select
                                        value={selectedValue}
                                        onChange={handleChangePrefix}
                                        // open={openPrefix}
                                        // onOpen={handleOpenPrefix}
                                        // onClose={handleClosePrefix}
                                        displayEmpty
                                        variant="outlined"
                                        sx={{
                                          width: "100%",
                                          height: "48px",
                                          backgroundColor: "#fff", // พื้นหลังสีขาว
                                          borderRadius: "26px", // ปรับให้โค้งเหมือน TextField
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: "26px", // ความโค้งของตัว select
                                            "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderRadius: "26px", // ความโค้งของเส้นขอบ
                                              borderColor: "green", // สีขอบปกติ
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "darkred", // สีขอบเมื่อ hover
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor:
                                                "#0288D1 !important", // สีขอบเมื่อ focus
                                            },
                                          },
                                        }}
                                      >
                                        {prefix.map((option) => (
                                          <MenuItem
                                            key={option.prefix}
                                            value={option.prefix}
                                          >
                                            {option.prefix}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </ListItem>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <Box
                                    sx={{
                                      borderRadius: "12px",
                                    }}
                                  >
                                    <Typography
                                      sx={{ pl: 11, color: "#686868" }}
                                    >
                                      ชื่อ-นามสกุล
                                    </Typography>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center", // จัดแนวในแนวนอน
                                        alignItems: "center", // จัดแนวในแนวตั้ง
                                        height: "10vh", // ตั้งความสูงให้เต็มหน้าจอ (ถ้าต้องการ)
                                      }}
                                    >

                                      <TextField
                                        sx={{
                                          pl: 7,
                                          width: "92%", // ปรับความกว้างตามต้องการ
                                          "& .MuiInputBase-root": {
                                            height: "48px",
                                          },
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: "30px",
                                            backgroundColor: "#fff",
                                          },
                                        }}
                                        // onChange={handleName}
                                        onChange={(e) => {
                                          const inputValue = e.target.value;
                                          const regex = /^[A-Za-zก-๙\s]*$/; // ตัวอักษรภาษาอังกฤษ และภาษาไทย
                                          if (regex.test(inputValue)) {
                                            handleName(
                                              e as React.ChangeEvent<HTMLInputElement>
                                            );
                                          }
                                        }}
                                        value={nameData}
                                        // disabled
                                        InputProps={{
                                          sx: {
                                            "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "green", // Default border color
                                            },
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <PersonSearchIcon
                                                sx={{ color: "gray" }}
                                              />
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <Box
                                    sx={{
                                      borderRadius: "12px",
                                    }}
                                  >
                                    <Typography
                                      sx={{ pl: 11, color: "#686868" }}
                                    >
                                      เลขประจำตัวประชาชนของพยาน
                                    </Typography>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        minHeight: "10vh",
                                      }}
                                    >
                                      <TextField
                                        inputProps={{ inputMode: "numeric", pattern: "\\d{1}-\\d{4}-\\d{5}-\\d{2}-\\d{1}" }}
                                        sx={{
                                          mt: 1,
                                          pl: 7,
                                          width: "92%", // ปรับความกว้างตามต้องการ
                                          "& .MuiInputBase-root": {
                                            height: "48px",
                                          },
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: "30px",
                                            backgroundColor: "#fff",
                                          },
                                        }}
                                        onChange={handleCid}
                                        value={cid}
                                        // disabled
                                        InputProps={{
                                          sx: {
                                            "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "green", // Default border color
                                            },
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <BadgeIcon
                                                sx={{ color: "gray" }}
                                              />
                                            </InputAdornment>
                                          ),
                                        }}
                                        error={errorCid ? true : false}
                                        helperText={errorCid === "errorLength" ? "กรุณากรอกเลขประจำตัวประชาชนของพยานให้ครบ 13 หลัก" : errorCid === "errorValidThaiIdCard" ? "กรุณากรอกเลขประจำตัวประชาชนของพยานให้ถูกต้อง" : ""}
                                      />
                                    </div>
                                  </Box>
                                </Grid>
                              </Grid>
                              {/* <Box sx={{ paddingTop: 3 }}>
                                <Typography sx={{ pl: 2, pb: 1 }}>
                                  ลำดับที่ 3 :{" "}
                                  <Typography
                                    component="span"
                                    sx={{ color: "#686868" }}
                                  >
                                    ผู้มีสิทธิ์อนุมัติ
                                  </Typography>
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  backgroundColor: "#F0F3F6",
                                  borderRadius: "12px",
                                  height: "90px",
                                  mt: 1,
                                }}
                              >
                                <ListItem alignItems="center">
                                  <ListItemAvatar>
                                    <img
                                      src={personimage}
                                      alt="รูปภาพ"
                                      style={{
                                        width: 22,
                                        height: "auto",
                                        top: 2,
                                      }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary="สิริกัญญา ผมงาม"
                                    secondary={
                                      <React.Fragment>
                                        <Typography
                                          component="span"
                                          variant="body2"
                                          sx={{
                                            fontSize: "14px",
                                            display: "inline",
                                            color: "#686868",
                                          }}
                                        >
                                          sirikanya.ph@inet.co.th
                                        </Typography>
                                      </React.Fragment>
                                    }
                                  />
                                </ListItem>
                              </Box> */}
                              {/* <Box sx={{ paddingTop: 3 }}>
                                <Typography sx={{ pl: 2, pb: 1 }}>
                                  ลำดับที่ 4 :{" "}
                                  <Typography
                                    component="span"
                                    sx={{ color: "#686868" }}
                                  >
                                    ผู้มีสิทธิ์อนุมัติ
                                  </Typography>
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  backgroundColor: "#F0F3F6",
                                  borderRadius: "12px",
                                  height: "90px",
                                  mt: 1,
                                }}
                              >
                                <ListItem alignItems="center">
                                  <ListItemAvatar>
                                    <img
                                      src={personimage}
                                      alt="รูปภาพ"
                                      style={{
                                        width: 22,
                                        height: "auto",
                                        top: 2,
                                      }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary="สิริกัญญา ผมงาม"
                                    secondary={
                                      <React.Fragment>
                                        <Typography
                                          component="span"
                                          variant="body2"
                                          sx={{
                                            fontSize: "14px",
                                            display: "inline",
                                            color: "#686868",
                                          }}
                                        >
                                          sirikanya.ph@inet.co.th
                                        </Typography>
                                      </React.Fragment>
                                    }
                                  />
                                </ListItem>
                              </Box> */}
                            </List>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: 11,
                          }}
                        >
                          {/* <DocumentSequenceDialog /> */}
                          <Button
                            disabled={!(selectedValue && nameData && cid.length === 13 && !errorCid)}
                            sx={{
                              backgroundColor: !selectedValue || !nameData || cid.length !== 13 || errorCid ? "#E6E6E6" : "#0288D1",
                              width: { xs: "140px", lg: "180px" }, // กำหนดความกว้างให้ปุ่มยาวขึ้น
                              color: "#fff",
                              borderRadius: 2,
                              "&:hover": {
                                backgroundColor: !selectedValue || !nameData || cid.length !== 13 || errorCid ? "#E6E6E6" : "#0277BD",
                              },
                            }}
                            onClick={handleOpenSecondDialog}
                          >
                            ลงนามลายเซ็นดิจิทัล
                          </Button>
                        </Grid>
                      </TabPanel>

                      <TabPanel value="2" sx={{ padding: 2 }}>
                        {/* <input
                          multiple
                          type="file"
                          accept="application/pdf"
                          ref={hiddenFileInputCreatePDF}
                          onChange={uploadPDF}
                          style={{ display: "none" }}
                        /> */}
                        <Grid
                          // onDrop={handleDrop}
                          // onDragOver={handleDragOver}
                          container
                          direction="row"
                          sx={{
                            // justifyContent: "center",
                            // alignItems: "center",
                            mt: 2,
                          }}
                        >
                          <Button
                            variant="outlined"
                            onClick={triggerFileInput}
                            sx={{
                              width: "100%",
                              border: "2px dashed #99b9f2",
                              color: "#1976d2",
                              padding: "18px",
                              backgroundColor: "#f4f9ff",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",

                              "&:hover": {
                                border: "2px dashed #1976d2",
                                backgroundColor: "#f4f9ff",
                              },
                            }}
                          >
                            <Grid
                              container
                              alignItems={"center"}
                              justifyContent={"center"}
                            >
                              <Grid item xs={2} xl={1}>
                                <div
                                  style={{
                                    backgroundColor: "#E4F2FC",
                                    width: 45,
                                    height: 45,
                                    borderRadius: 50,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <img
                                    src={icon_import}
                                    alt="icon_import"
                                    style={{
                                      width: "30px",
                                      height: "auto",
                                    }}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs>
                                <Typography
                                  sx={{ color: "#0172B9", fontSize: 14 }}
                                >
                                  อัปโหลดเอกสารใบสมัครเพิ่มเติม (สูงสุด 5 ไฟล์)
                                </Typography>
                              </Grid>
                            </Grid>
                          </Button>
                        </Grid>
                        {/* <Button
                          fullWidth
                          variant="contained"
                          disabled={selectedFiles.length === 0}
                          sx={{
                            backgroundColor: "#003466",
                            borderRadius: 3,
                            mt: 3,
                            mb: 3,
                          }}
                        >
                          บันทึก
                        </Button> */}
                        <Typography
                          sx={{
                            paddingTop: 3,
                            color: "#003466",
                            fontSize: 20,
                            fontWeight: 500,
                          }}
                        >
                          เอกสารที่อัปโหลด
                        </Typography>
                        <Box sx={{ paddingTop: 1 }}>
                          <List style={{ paddingTop: 13 }}>
                            {getFiles.length > 0 ? (
                              getFiles.map((file, index) => (
                                <ListItem
                                  key={index}
                                  secondaryAction={
                                    <IconButton
                                      edge="end"
                                      aria-label="delete"
                                      onClick={() =>
                                        handleDelete(file.files_name, file._id)
                                      }
                                    >
                                      <img
                                        src={logo_del}
                                        alt="logo_del"
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                        }}
                                      />
                                    </IconButton>
                                  }
                                >
                                  <ListItemIcon>
                                    <img
                                      src={icon_pdf}
                                      alt="icon_pdf"
                                      style={{
                                        width: "35px",
                                        height: "35px",
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={file.files_name + ".pdf"}
                                  />
                                </ListItem>
                              ))
                            ) : (
                              <Box
                                sx={{
                                  width: "100%",
                                  height: 300,
                                  backgroundColor: "#F5F7FA",
                                  borderRadius: 3,
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                  padding: 2,
                                }}
                              >
                                <img
                                  src={no_documents}
                                  alt="No Documents"
                                  style={{
                                    width: 60,
                                    height: 60,
                                    marginBottom: 8,
                                  }}
                                />
                                <Typography
                                  sx={{ fontWeight: 600, color: "#1F3B63" }}
                                >
                                  ไม่มีเอกสาร
                                </Typography>
                              </Box>
                            )}
                          </List>
                        </Box>
                      </TabPanel>
                    </TabContext>
                  )}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <DialogAttachDocPDF
          getFilesPDF={getFilesPDF}
          dataPageForm={dataPageForm}
          setOpenAttachDoc={setOpenAttachDoc}
          openAttachDoc={openAttachDoc}
          setLoading={setLoading}
          fileslength={getFiles.length}
        />
        <SignSignatureDialog
          arrrayOfPdf={arrrayOfPdf}
          prefixValue={selectedValue}
          nameValue={nameData}
          cidValue={cid}
          dataPageForm={dataPageForm}
          getFiles={getFiles}
          getBase64OfSign={base64OfSign || ''}
          setLoading={setLoading}
          setOpenSecondDialog={setOpenSecondDialog}
          openSecondDialog={openSecondDialog}
          localStorageData={localStorageData}
        />
        <DialogNoInformationFound openErrorDialog={openNoInformationFound} setOpenErrorDialog={setOpenNoInformationFound} />
        {/* <SignatureDrawing /> modal วาดลายเซ็น */}
      </Grid>
    </Box>
  );
};

export default IndexDocumentPer;
